module.exports = "/images/vendor/flag-icon-css/flags/1x1/ne.svg?e56edd30b77ac6f1cae9bf153b1f9ec7";